<template>
  <div>
    <div class="black-overlay"></div>

    <div class="modal modal--welcomeback modal--zero-balance modal--purchase" id="password_updated">
      <div class="modal__content">
        <button class="btn modal-close">
          <i class="icon-close"></i>
        </button>

        <div class="modal__header">
          <h1>{{ getTranslations.home_modal_success_password_change_title }}</h1>

          <img class="usericon" src="static/images/eye_face.svg" alt="">
        </div>

        <div class="modal__body">
          <p>{{ getTranslations.home_modal_success_password_change_description }}</p>
        </div>
      </div>
    </div>

    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SuccessPasswordChange',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/SuccessPasswordChange.vue